// sentry.client.config.ts
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"TzSGAn1AnT8hbsN6olvZ8"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";
import { createSentryConfig } from "@/lib/sentry-base";
import Logger from '@/lib/logger';

const logger = new Logger('pbs:sentry:client:config');

const config = createSentryConfig({
  integrations: process.env.NODE_ENV === 'production' ? [Sentry.replayIntegration()] : [],
});

if (config.environment !== 'development') {
  logger.debug(`Enabling Sentry for ${config.environment}...`);
}

Sentry.init(config);